import React from 'react';
import { FaCheckCircle, FaTimes } from 'react-icons/fa';

const FeedbackSuccessModal = ({ isOpen, onClose, isDarkMode }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div
                className={`w-full max-w-sm rounded-2xl shadow-2xl p-6 text-center transform transition-all scale-100 ${isDarkMode ? "bg-gray-800 text-gray-100" : "bg-white text-gray-900"
                    } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
                <button
                    onClick={onClose}
                    className={`absolute top-4 right-4 p-2 rounded-full transition-colors ${isDarkMode ? "hover:bg-gray-700 text-gray-400 hover:text-white" : "hover:bg-gray-100 text-gray-500 hover:text-gray-900"
                        }`}
                >
                    <FaTimes />
                </button>

                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-green-100 text-green-500 rounded-full flex items-center justify-center text-3xl animate-[bounce_1s_ease-in-out]">
                        <FaCheckCircle />
                    </div>
                </div>

                <h3 className="text-xl font-bold mb-2">Thank You!</h3>
                <p className={`text-sm mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
                    Your feedback submitted successfully. It's valuable for us.
                </p>

                <button
                    onClick={onClose}
                    className="w-full py-2.5 bg-cyan-500 hover:bg-cyan-600 text-white rounded-xl font-medium transition-all shadow-lg shadow-cyan-500/25"
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default FeedbackSuccessModal;
